<div class="main-wrapper">
  <div class="auth-sidebar">
    <div class="header">
      <a [routerLink]="session_info?.last_routes.new_home || '/'">
        <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
      </a>
      <h3>QR code-accessible web pages for all use cases</h3>
    </div>
  </div>
  <div class="auth-contents">
    <div class="form-contents">
      <div class="form-header">
        <a [routerLink]="session_info?.last_routes.new_home || '/'" class="d-lg-none">
          <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
        </a>
        <h2>Sign up</h2>
        <p class="lg">Already have an account? <a routerLink="/auth/signin">Sign in</a></p>
      </div>
      <app-auth-google></app-auth-google>
      <div class="line">
        <span>OR</span>
        <hr />
      </div>
      <form #signupForm="ngForm" [formGroup]="signup_form" (ngSubmit)="createUser()" class="animated fadeIn">
        <ng-container *ngIf="authState$ | async; let auth_state">

          <div class="mb-3">
            <label class="form-label bold">Full name</label>
            <input type="text" formControlName="name" required maxlength="60"
              [class.is-invalid]="signup_form.get('name').hasError('required') && signup_form.get('name').touched"
              class="form-control">
            <ng-container *ngIf="signup_form.get('name').touched">
              <p class="input-error" *ngIf="signup_form.get('name').hasError('required')">
                Full name is required!</p>
              <p class="input-error" *ngIf="signup_form.get('name').hasError('invalidCharacterInName')">
                Invalid characters found in name!</p>
            </ng-container>

          </div>
          <div class="mb-3">
            <label class="form-label bold">Email</label>
            <input type="text" formControlName="email" required maxlength="60"
              [class.is-invalid]="(signup_form.get('email').hasError('required') && signup_form.get('email').touched) || error"
              class="form-control">
            <ng-container *ngIf="signup_form.get('email').touched">
              <p class="input-error" *ngIf="signup_form.get('email').hasError('required')">
                Email is required!</p>
              <p class="input-error" *ngIf="signup_form.get('email').hasError('email')">
                Email is invalid!</p>
            </ng-container>
            <p class="input-error" *ngIf="error">
              {{error}}</p>
          </div>
          <app-auth-password-inputs [data]="signup_form"></app-auth-password-inputs>
          <div class="alert alert-success d-flex align-items-center animated fadeIn mt-4" role="alert" *ngIf="success">
            <i class="bi bi-check-circle-fill"></i>
            <div>{{success}}</div>
          </div>
          <button type="submit" class="btn btn-secondary btn-block mt-4"
            [disabled]="auth_state.status === state_statuses.PROCESSING">
            <app-inline-loader
              *ngIf="auth_state.status === state_statuses.PROCESSING && auth_state.data.auth_type === auth_types.EMAIL; else notProcessing"></app-inline-loader>
            <ng-template #notProcessing>
              <span>Register</span>
            </ng-template>
          </button>

          <div class="mt-3">
            <small>By creating an account you agree to our <a routerLink="/terms" target="_blank">terms</a>
              & <a routerLink="/privacy-policy" target="_blank">privacy
                policy</a></small>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>